import React from "react";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import MDDialog from "components/MDDialog";
import MDTextButton from "components/MDTextButton";
import MDButton from "components/MDButton";
import { Box, Checkbox } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ReactivationRequestDialog = (props) => {
  const {
    dialogTitle,
    dialogOpen,
    onClose,
    action,
    buttonLabel,
    confirmationText,
    btnColor,
    isAutoRenew,
    setIsAutoRenew,
  } = props;

  return (
    <MDDialog
      dialogTitle={dialogTitle}
      dialogOpen={dialogOpen}
      dialogClose={onClose}
      TransitionComponent={Transition}
      maxWidth="sm"
    >
      <DialogContent dividers>
        <Typography variant="subtitle1" fontSize={16} fontWeight="regular">
          {confirmationText || "Are you sure you want to delete?"}
        </Typography>

        <Box display="flex" alignItems="center" mt={2}>
          <Typography variant="subtitle2" fontWeight="bold" color="text">
            Do you want to enable auto-renew?
          </Typography>
          <Checkbox
            id="isAutoRenew"
            name="isAutoRenew"
            checked={!!isAutoRenew} 
            onChange={(e) => setIsAutoRenew(e.target.checked)}
            inputProps={{ "aria-label": "Enable auto-renew" }}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <MDTextButton onClick={onClose}>Cancel</MDTextButton>
          <MDButton
            size="small"
            variant="contained"
            color={btnColor || "primary"}
            onClick={action}
          >
            {buttonLabel || "Delete"}
          </MDButton>
        </Stack>
      </DialogActions>
    </MDDialog>
  );
};

export default ReactivationRequestDialog;
